import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState, StateFromRoot, registerReducer, store } from "@core/store"
import { GridPaginationModel } from "@mui/x-data-grid-pro"
import { GRID_PAGE_SIZE_OPTIONS } from "@/core/constants"
import { TgstatBot } from "../interfaces"

export interface TgstatBotState {
  showHidden?: boolean
  myChatsFilters?: TgstatBot.GetMyChatsFilters
  inviteLinksFilters?: TgstatBot.GetInviteLinksFilters
}

const STATE_KEY = "tgstatBot"
export const CONFIG_KEY = `${STATE_KEY}_state`

type TableName = "inviteLinks" | "myChats"
const defaultTableState: GridPaginationModel & TgstatBotState = {
  page: 0,
  pageSize: GRID_PAGE_SIZE_OPTIONS[2],
  showHidden: false,
  myChatsFilters: {},
  inviteLinksFilters: {},
}
type IState = {
  [table in TableName]: GridPaginationModel
} & TgstatBotState

const persistantState = localStorage.getItem(CONFIG_KEY)
const emptyState: IState = {
  inviteLinks: defaultTableState,
  myChats: defaultTableState,
}

const initialState: IState = persistantState
  ? { ...emptyState, ...JSON.parse(persistantState) }
  : emptyState

export const tgstatBotSlice = createSlice({
  name: "tgstatBot",
  initialState: initialState,
  reducers: {
    setInviteLinksPaginationModel: (
      state,
      { payload: model }: PayloadAction<GridPaginationModel>,
    ) => {
      state.inviteLinks = model
    },
    setMyChatsPaginationModel: (
      state,
      { payload: model }: PayloadAction<GridPaginationModel>,
    ) => {
      state.inviteLinks = model
    },
    setShowHidden: (state, { payload: showHidden }: PayloadAction<boolean>) => {
      state.showHidden = showHidden
    },
    setMyChatsFilter: (
      state,
      { payload: filter }: PayloadAction<TgstatBotState["myChatsFilters"]>,
    ) => {
      state.myChatsFilters = filter
    },
    setInviteLinksFilter: (
      state,
      { payload: filter }: PayloadAction<TgstatBotState["inviteLinksFilters"]>,
    ) => {
      state.inviteLinksFilters = filter
    },
  },
})
registerReducer(tgstatBotSlice.name, tgstatBotSlice.reducer)
store.subscribe(() => {
  localStorage.setItem(CONFIG_KEY, JSON.stringify(store.getState()[STATE_KEY]))
})

export const {
  setInviteLinksPaginationModel,
  setMyChatsPaginationModel,
  setShowHidden,
  setInviteLinksFilter,
  setMyChatsFilter,
} = tgstatBotSlice.actions

export const getTgstatBotState = (state: RootState<StateFromRoot<IState>>) =>
  state[STATE_KEY]
